











import { Prop, Component, Vue } from 'vue-property-decorator'
import { PipelinePhaseCategory } from '@/api/types'
import { getColorForPhaseCategory } from '@/helpers/color'
import { ReferralStats } from '@/api/model/referral-stats'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class PipelineTabPhaseCategory extends Vue {
    @Prop({ required: true }) readonly category!: PipelinePhaseCategory
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.State readonly phaseCategoryFilter!: PipelinePhaseCategory
    @referrals.Action applyPipelinePhaseCategoryFilter: ({ category: PipelinePhaseCategory }) => Promise<void>

    get title(): string {
        return this.$t(`pipeline-phase.category.${this.category}`).toString()
    }

    get countBackgroundColor(): string {
        return getColorForPhaseCategory(this.category, .25)
    }

    get countColor(): string {
        return getColorForPhaseCategory(this.category)
    }

    get active(): boolean {
        return this.category === this.phaseCategoryFilter
    }

    activate(): void {
        this.applyPipelinePhaseCategoryFilter({
            category: this.category,
        })
    }
}
